<template>
    <div class="width100">
        <b-modal id="modalInfo" hide-footer
                 header-bg-variant="thtab"
                 header-text-variant="light">
            <template v-slot:modal-title>

            </template>
            <div class="d-block">
                <div v-if="errors2.length" class="alert alert-danger text-center" role="alert">
                    <p v-for="(error, key) in errors2" :key="key">{{ error }}</p>
                </div>
                <div v-if="msgs2.length" class="alert alert-success text-center" role="alert">
                    <p v-for="(msg, key) in msgs2" :key="key">{{ msg }}</p>
                </div>
            </div>
        </b-modal>

        <div class="row">
            <div class="col-10  offset-1">

                <div class="row">
                    <div class="col-4">
                        Titre
                    </div>
                    <div class="col-8">
                        <input type="text" v-model="titrePanne" class="form-control">
                    </div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-4">
                        Défaut constaté
                    </div>
                    <div class="col-8">
                        <textarea v-model="defautPanne" class="form-control"></textarea>
                    </div>
                </div>
                <br />
                <!--<Picture @returnPicture="returnPicture" ></Picture>-->
                <PictureNav @returnPictureNav="returnPictureNav"></PictureNav>
                <br />
                <div class="col-12 text-center">
                    <i v-if="dataUrl2 || image" class="fa-regular fa-trash-can fa-2x text-danger" @click="deletePicture()"></i>
                </div>
                <div class="row" v-if="dataUrl3!=[]">
                    <div class="col-12">
                        <p>Ces photos seront jointes à la panne :</p>
                        <b-img v-for="(dataUrl, key) in dataUrl3" :key="key"

                                :src="dataUrl" fluid-grow
                               alt="Responsive image"></b-img>
                    </div>
                </div>
                <!--<div class="row" v-if="dataUrl2">
                    <div class="col-12">
                        <p>Cette photo sera jointe à la panne :</p>
                        <b-img :src="dataUrl2" fluid-grow
                               alt="Responsive image"></b-img>
                    </div>
                </div>-->
                <p v-if='dataUrl2==null && image!=null' v-html="image"></p>
                <br/>
                <div class="row">
                    <div class="col-12 text-center">
                        <button class="btn btn-primary" block @click="savePanne()">
                            Valider
                        </button>
                        &nbsp;
                        <button class="btn btn-danger" block @click="returnAMaintenance()">Retour</button>
                        &nbsp;
                        <button v-if='idModif!=null' class="btn btn-danger" block @click="deletePanne()">Supprimer</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PictureNav from './PictureNav';

    export default {
        name: "PanneDeclarationFormulaire",
        props: ['token', 'site', 'user', 'racine', 'machine', 'userId','machineType','idModif','systemeClient'],
        data() {
            return {
                titrePanne:null,defautPanne:null, errors2:[], msgs2:{1:'ytegfg'},
                blob2:null,dataUrl2:null,image:null,
                blob3:[],dataUrl3:[],image3:[]
            };
        },
        methods:
        {
            savePanne()
            {
                this.errors2 = [];
                this.msgs2 = [];
                if(this.titrePanne!=null)
                {
                    if(this.defautPanne!=null) {

                        const h = this.$createElement

                        const messageVNode = (h('div', { class: ['foobar'] }, [
                            h('p', { class: ['text-center'] }, [
                                h('strong', 'Récapitulatif : '),
                            ]),
                            h('div', { class: ['foobar'] }, [
                                h('p', { class: ['text-center'] }, [
                                    "Titre : "+this.titrePanne
                                ]),
                                h('p', { class: ['text-center'] }, [
                                    "Défaut : "+this.defautPanne
                                ]),
                            ])
                        ]))


                        this.$bvModal.msgBoxConfirm(messageVNode, {
                            title: 'Validation',
                            size: 'lg',
                            buttonSize: 'lg',
                            okVariant: 'danger',
                            okTitle: 'Oui',
                            cancelTitle: 'Non',
                            footerClass: 'p-2',
                            hideHeaderClose: false,
                            centered: true,
                            noFade: true
                        })
                            .then(value => {
                                if (value == true) {


                                    var today = new Date()
                                    var month = today.getMonth() + 1
                                    var day = today.getDate()
                                    if (month < 10) {
                                        month = "0" + month
                                    }
                                    if (day < 10) {
                                        day = "0" + day
                                    }

                                    var myHeaders = new Headers();
                                    myHeaders.append("Authorization", "Bearer "+this.token);
                                    //myHeaders.append("Content-Type", "multipart/form-data");

                                    var formdata = new FormData();
                                    formdata.append('date', today.getFullYear() + '-' + month + '-' + day);
                                    formdata.append('machine', this.machine['id']);
                                    formdata.append('user', this.userId);
                                    formdata.append('solution', '');
                                    formdata.append('titre', this.titrePanne);
                                    formdata.append('defaut', this.defautPanne);
                                    formdata.append('idModif', this.idModif);
                                    //formdata.append('photos', this.blob3);
                                    /*this.blob3.forEach((blob, index) => {
                                        const file = new File([blob], `photo-${index}.jpg`, { type: 'image/jpeg' });
                                        formdata.append('photos[]', file);
                                    });*/
                                    console.log(this.blob3);

                                    this.blob3.forEach((base64Image, index) => {
                                        const mimeType = base64Image.split(';')[0].split(':')[1]; // Extract MIME type
                                        const blob = this.base64ToBlob(base64Image, mimeType);
                                        formdata.append(`photos[]`, blob, `photo-${index}.jpg`); // Name each file
                                    });

                                    /*var requestOptions = {
                                        method: 'POST',
                                        headers: myHeaders,
                                        body: formdata,
                                        //redirect: 'follow'
                                    };*/

                                    fetch(this.racine + this.site + 'api/save_panne_multi_photo', {
                                        method: 'POST',
                                        headers: myHeaders,
                                        body: formdata
                                    })
                                        .then(response => response.json())
                                        .then(json => {
                                            console.log(json);
                                            // Handle success or failure
                                            if (json['msg']) {
                                                this.errors2.push(json['msg']);
                                                this.popup();
                                            } else if (json['valide'] > 0) {
                                                this.msgs2.push("La déclaration de panne est effectuée.");
                                                this.popup();
                                                setTimeout(() => {
                                                    this.$emit('returnMaintenance');
                                                }, 5000);
                                            } else {
                                                this.errors2.push("Un problème inconnu s'est produit.");
                                                this.popup();
                                            }
                                        });

                                    /*fetch(this.racine + this.site + 'api/save_panne_multi_photo',requestOptions)
                                        .then(response => response.json())
                                        .then(json => {
                                            console.log(json);
                                            if (json['msg'] != "") {
                                                this.errors2.push(json['msg'])
                                                this.popup()
                                            }
                                            else if (json['valide'] > 0) {
                                                this.msgs2.push("La déclaration de panne est effectuée.")
                                                this.popup()
                                                setTimeout(() => {//on laisse le message quelques instants
                                                    this.$emit('returnMaintenance')
                                                }, 5000)

                                            }
                                            else {
                                                this.errors2.push("Un problème inconnu s'est produit.")
                                                this.popup()
                                            }
                                        })*/
                                }})
                    }
                    else
                    {
                        this.errors2.push("Le défaut n'est pas correct.")
                        this.popup()
                    }
                }
                else
                {
                    this.errors2.push("Le titre n'est pas correct.")
                    this.popup()
                }
            },
            base64ToBlob(base64, mimeType) {
                const byteString = atob(base64.split(',')[1]); // Decode Base64 string
                const arrayBuffer = new ArrayBuffer(byteString.length);
                const uint8Array = new Uint8Array(arrayBuffer);
                for (let i = 0; i < byteString.length; i++) {
                    uint8Array[i] = byteString.charCodeAt(i);
                }
                return new Blob([arrayBuffer], { type: mimeType });
            },
            popup()
            {
                this.$bvModal.show('modalInfo')
                setTimeout(() => {//on laisse le message quelques instants
                    this.$bvModal.hide('modalInfo')
                    this.errors2 = []
                    this.msgs2 = []
                }, 2000)
            },
            returnPicture(e)
            {
                console.log("picture")
                console.log(e)
                this.blob2 = e[0]
                this.dataUrl2 = e[1]
                this.dataUrl3.push(e[1])
                this.blob3.push(e[1])
            },
            returnPictureNav(e) {
                console.log("picture")
                console.log(e)
                this.blob2 = e[0]
                this.dataUrl2 = e[1]
                this.dataUrl3.push(e[1])
                this.blob3.push(e[1])
            },
            ifModif()
            {
                if(this.idModif!=null)
                {
                    fetch(this.racine + this.site + 'api/pannes/'+this.idModif, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        },
                    }).then(response => {

                        console.log(response)
                        response.json().then(json => {
                            if (json != undefined) {
                                console.log(json)
                                this.defautPanne = json['defaut']
                                this.titrePanne = json['titre']
                                this.machine = json['machine']
                                fetch(this.racine + this.site + 'api/get_photo_stat/'+this.idModif+'/panneDeclaration/1', {
                                    method: 'GET',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Authorization': 'Bearer ' + this.token
                                    },
                                }).then(response => {
                                    console.log(response)
                                    response.json().then(json => {
                                        if (json != undefined) {
                                            console.log(json)
                                            this.image = json['img']
                                        }
                                    })
                                })
                            }
                        })
                    })
                }
            },
            deletePictureFinal()
            {
                if (this.dataUrl3 != []) {
                    this.dataUrl3 = []
                    this.blob3 = []
                }
                else if (this.image != null && this.idModif != null) {
                    fetch(this.racine + this.site + 'api/delete_photo/'+this.idModif+'/panneDeclaration', {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        },
                    }).then(response => {
                        console.log(response)
                        response.json().then(json => {
                            if (json != undefined) {
                                console.log(json)
                                this.image = json['img']
                            }
                        })
                    })
                }
            },
            deletePicture()
            {
                this.$bvModal.msgBoxConfirm("Voulez vous supprimer cette image ?", {
                    title: 'Confirmation',
                    size: 'lg',
                    buttonSize: 'lg',
                    okVariant: 'danger',
                    okTitle: 'Oui',
                    cancelTitle: 'Non',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true,
                    noFade: true
                })
                    .then(value => {
                        if (value == true) {
                            this.deletePictureFinal()
                        }
                    })
            },
            deletePanne()
            {
                this.$bvModal.msgBoxConfirm("Voulez vous supprimer cette panne ?", {
                    title: 'Confirmation',
                    size: 'lg',
                    buttonSize: 'lg',
                    okVariant: 'danger',
                    okTitle: 'Oui',
                    cancelTitle: 'Non',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true,
                    noFade: true
                })
                    .then(value => {
                        if (value == true) {

                            fetch(this.racine + this.site + 'api/pannes/'+this.idModif, {
                                method: 'DELETE',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': 'Bearer ' + this.token
                                },
                            }).then(response => {
                                console.log(response)
                                if (response.status == 204)
                                {
                                    /*this.msgs2.push("La suppression a bien été effectué.")
                                    this.popup()*/
                                    this.deletePictureFinal()
                                    setTimeout(() => {//on laisse le message quelques instants
                                        this.$emit('returnMaintenance')
                                    }, 1000)
                                }
                            })

                        }
                    })
            },
            returnAMaintenance()
            {
                this.$emit('returnMaintenance')
            }

        },
        created() {
            this.ifModif()
        },
        components: {
            PictureNav,
        }
    }
</script>

<style scoped>

</style>